import React from 'react';
import { FaTrash } from 'react-icons/fa';
import { formatPrice } from '../../../../utils/priceUtils.js';

const ConfirmPackagesCard = ({
  event,
  packages,
  delegations,
  validationErrors,
  generalError,
  onUpdatePackageDetail,
  onRemovePackage,
  onAddPackage,
  onSubmitPurchase,
  submitting,
  packageOptions,
  showModal,
  onSelectPackage,
  onCloseModal,
  subtotal,
  serviceFee,
  totalAmount,
}) => {
  console.log('🔍 ConfirmPackagesCard render:', {
    packageOptions: packageOptions,
    packageOptionsLength: packageOptions?.length || 0
  });

  const isPackageSoldOut = (pkg) => {
    console.log('🔍 isPackageSoldOut called with:', pkg);
    
    const now = new Date();
    const sold = pkg.sold || 0;
    const held = pkg.held || 0;
    const total = pkg.total || 0;
    const soldOut = (sold + held) >= total && total > 0;
    
    // Check date validity if dates are available
    let dateValid = true;
    if (pkg.validFrom && pkg.validTo) {
      const validFrom = new Date(pkg.validFrom);
      const validTo = new Date(pkg.validTo);
      dateValid = now >= validFrom && now <= validTo;
      console.log('📅 Date check (validFrom/validTo):', {
        packageName: pkg.name,
        validFrom: pkg.validFrom,
        validTo: pkg.validTo,
        parsedValidFrom: validFrom.toISOString(),
        parsedValidTo: validTo.toISOString(),
        now: now.toISOString(),
        nowValidFrom: now >= validFrom,
        nowValidTo: now <= validTo,
        dateValid
      });
    } else if (pkg.validFromDate && pkg.validToDate) {
      const validFrom = new Date(pkg.validFromDate);
      const validTo = new Date(pkg.validToDate);
      dateValid = now >= validFrom && now <= validTo;
      console.log('📅 Date check (validFromDate/validToDate):', {
        packageName: pkg.name,
        validFromDate: pkg.validFromDate,
        validToDate: pkg.validToDate,
        parsedValidFrom: validFrom.toISOString(),
        parsedValidTo: validTo.toISOString(),
        now: now.toISOString(),
        nowValidFrom: now >= validFrom,
        nowValidTo: now <= validTo,
        dateValid
      });
    }
    
    const isDisabled = soldOut || !dateValid;
    
    console.log('🔍 Package availability check:', {
      packageName: pkg.name,
      sold,
      held,
      total,
      soldPlusHeld: sold + held,
      soldOut,
      dateValid,
      isDisabled,
      validFrom: pkg.validFrom || pkg.validFromDate,
      validTo: pkg.validTo || pkg.validToDate,
      now: now.toISOString()
    });
    
    return isDisabled;
  };

  return (
    <div className="ticket-confirm-card">
      <div className="ticket-confirm-card__header">
        <h2 className="ticket-confirm-card__title">Ticket Details</h2>
      </div>

      {generalError && (
        <div className="ticket-confirm-error ticket-confirm-error--general">
          {generalError}
        </div>
      )}

      <div className="ticket-confirm-packages">
        {packages.map((pkg, index) => (
          <div key={index} className="ticket-confirm-package">
            <div className="ticket-confirm-package__header">
              <div className="ticket-confirm-package__title-group">
                <span className="ticket-confirm-package__number">Package {index + 1}</span>
                <span className="ticket-confirm-package__type">
                  {pkg.packageDetails}
                </span>
              </div>
              <div className="ticket-confirm-package__amount">{pkg.amount}</div>
              <button
                type="button"
                className="ticket-confirm-package__remove-btn"
                onClick={() => onRemovePackage(index)}
                title="Remove Package"
              >
                <FaTrash />
              </button>
            </div>

            <div className="ticket-confirm-section">
              <h4 className="ticket-confirm-section__title">Personal Information</h4>
              <div className="ticket-confirm-grid">
                <div className="ticket-confirm-field">
                  <label className="ticket-confirm-field__label">Title</label>
                  <select
                    value={pkg.title}
                    onChange={(e) => onUpdatePackageDetail(index, 'title', e.target.value)}
                    disabled={!pkg.isNewlyAdded}
                    className="ticket-confirm-field__input"
                  >
                    <option>Prof</option>
                    <option>Dr</option>
                    <option>Mr</option>
                    <option>Mrs</option>
                    <option>Ms</option>
                    <option>Miss</option>
                    <option>Prefer not to say</option>
                  </select>
                </div>

                <div className="ticket-confirm-field">
                  <label className="ticket-confirm-field__label">Full Name</label>
                  <input
                    type="text"
                    value={pkg.name}
                    onChange={(e) => onUpdatePackageDetail(index, 'name', e.target.value)}
                    placeholder="Enter full name"
                    className={
                      validationErrors[`${index}-name`]
                        ? 'ticket-confirm-field__input ticket-confirm-field__input--error'
                        : 'ticket-confirm-field__input'
                    }
                    readOnly={!pkg.isNewlyAdded}
                  />
                  {validationErrors[`${index}-name`] && (
                    <div className="ticket-confirm-error">
                      {validationErrors[`${index}-name`]}
                    </div>
                  )}
                </div>

                <div className="ticket-confirm-field">
                  <label className="ticket-confirm-field__label">Gender</label>
                  <select
                    value={pkg.gender}
                    onChange={(e) => onUpdatePackageDetail(index, 'gender', e.target.value)}
                    disabled={!pkg.isNewlyAdded}
                    className="ticket-confirm-field__input"
                  >
                    <option>Male</option>
                    <option>Female</option>
                    <option>Other</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="ticket-confirm-section">
              <h4 className="ticket-confirm-section__title">Contact Information</h4>
              <div className="ticket-confirm-grid">
                <div className="ticket-confirm-field">
                  <label className="ticket-confirm-field__label">Email Address</label>
                  <input
                    type="email"
                    value={pkg.email}
                    onChange={(e) => onUpdatePackageDetail(index, 'email', e.target.value)}
                    placeholder="Enter email address"
                    className={
                      validationErrors[`${index}-email`]
                        ? 'ticket-confirm-field__input ticket-confirm-field__input--error'
                        : 'ticket-confirm-field__input'
                    }
                    readOnly={!pkg.isNewlyAdded}
                  />
                  {validationErrors[`${index}-email`] && (
                    <div className="ticket-confirm-error">
                      {validationErrors[`${index}-email`]}
                    </div>
                  )}
                </div>

                <div className="ticket-confirm-field">
                  <label className="ticket-confirm-field__label">Phone Number</label>
                  <input
                    type="text"
                    value={pkg.phone}
                    onChange={(e) => onUpdatePackageDetail(index, 'phone', e.target.value)}
                    placeholder="Enter 10-digit phone number"
                    className={
                      validationErrors[`${index}-phone`]
                        ? 'ticket-confirm-field__input ticket-confirm-field__input--error'
                        : 'ticket-confirm-field__input'
                    }
                    readOnly={!pkg.isNewlyAdded}
                  />
                  {validationErrors[`${index}-phone`] && (
                    <div className="ticket-confirm-error">
                      {validationErrors[`${index}-phone`]}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="ticket-confirm-section">
              <h4 className="ticket-confirm-section__title">Event Information</h4>
              <div className="ticket-confirm-grid">
                <div className="ticket-confirm-field">
                  <label className="ticket-confirm-field__label">Delegation</label>
                  <select
                    value={pkg.delegation}
                    onChange={(e) => onUpdatePackageDetail(index, 'delegation', e.target.value)}
                    disabled={!pkg.isNewlyAdded}
                    className="ticket-confirm-field__input"
                  >
                    {delegations.map((delegation, i) => (
                      <option key={i} value={delegation}>
                        {delegation}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="ticket-confirm-field">
                  <label className="ticket-confirm-field__label">Number of Tickets</label>
                  <input
                    type="number"
                    min="1"
                    value={pkg.tickets}
                    onChange={(e) => onUpdatePackageDetail(index, 'tickets', e.target.value)}
                    className="ticket-confirm-field__input"
                    readOnly={!pkg.isNewlyAdded}
                  />
                </div>

                <div className="ticket-confirm-field">
                  <label className="ticket-confirm-field__label">IEEE Number</label>
                  <input
                    type="text"
                    value={pkg.ieeeNumber}
                    onChange={(e) => onUpdatePackageDetail(index, 'ieeeNumber', e.target.value)}
                    placeholder="Enter 8-digit IEEE number"
                    className={
                      validationErrors[`${index}-ieeeNumber`]
                        ? 'ticket-confirm-field__input ticket-confirm-field__input--error'
                        : 'ticket-confirm-field__input'
                    }
                    readOnly={!pkg.isNewlyAdded}
                  />
                  {validationErrors[`${index}-ieeeNumber`] && (
                    <div className="ticket-confirm-error">
                      {validationErrors[`${index}-ieeeNumber`]}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {subtotal > 0 && (
        <div className="ticket-confirm-price-summary">
          <div className="ticket-confirm-price-row">
            <span className="ticket-confirm-price-label">Subtotal</span>
            <span className="ticket-confirm-price-value">{formatPrice(subtotal)}</span>
          </div>
          <div className="ticket-confirm-price-row">
            <span className="ticket-confirm-price-label">Service fee</span>
            <span className="ticket-confirm-price-value">{formatPrice(serviceFee)}</span>
          </div>
          <div className="ticket-confirm-price-row ticket-confirm-price-row--total">
            <span className="ticket-confirm-price-label">Total</span>
            <span className="ticket-confirm-price-value">{formatPrice(totalAmount)}</span>
          </div>
        </div>
      )}

      <div className="ticket-confirm-actions">
        <button
          type="button"
          className="ticket-confirm-add-btn"
          onClick={onAddPackage}
        >
          + Add Package
        </button>

        <button
          type="button"
          className="ticket-confirm-submit-btn"
          onClick={onSubmitPurchase}
          disabled={submitting}
        >
          {submitting ? 'Processing...' : 'Submit Purchase'}
        </button>
      </div>

      {showModal && (
        <div className="ticket-confirm-modal">
          <div className="ticket-confirm-modal__content">
            <h3 className="ticket-confirm-modal__title">Select a Package</h3>
            <div className="ticket-confirm-modal__options">
              {packageOptions.map((pkg, index) => {
                const isDisabled = isPackageSoldOut(pkg);
                const isSoldOut = pkg.sold >= pkg.total;
                const isDateInvalid = !isDisabled && isSoldOut === false; // If disabled but not sold out, it must be date issue
                
                return (
                  <button
                    key={index}
                    type="button"
                    className={`ticket-confirm-modal__option ${isDisabled ? 'ticket-confirm-modal__option--sold-out' : ''}`}
                    onClick={() => !isDisabled && onSelectPackage(pkg)}
                    disabled={isDisabled}
                    title={
                      isSoldOut 
                        ? 'This package is sold out' 
                        : isDateInvalid 
                          ? 'This package is not currently available' 
                          : `Select ${pkg.name}`
                    }
                  >
                    <span className="ticket-confirm-modal__option-name">{pkg.name}</span>
                    <span className="ticket-confirm-modal__option-price">{pkg.price}</span>
                    {isSoldOut && (
                      <span className="ticket-confirm-modal__sold-out-badge">Sold Out</span>
                    )}
                    {isDateInvalid && !isSoldOut && (
                      <span className="ticket-confirm-modal__sold-out-badge">Unavailable</span>
                    )}
                  </button>
                );
              })}
            </div>
            <button
              type="button"
              className="ticket-confirm-modal__close-btn"
              onClick={onCloseModal}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConfirmPackagesCard;
